import React from "react";
import styled from "styled-components";
import BrandSlider from "../Elements/BrandSlider";

export default function Brands() {
  return (
    <Wrapper id="brands">
      <div className="lightBg" style={{ padding: "40px 0 50px" }}>
      <div className="container margin-bt-20">
        <h1 className="font40 extraBold textCenter margin-bt-5">
          Marcas
        </h1>
        <p class="font15 textCenter">
          Veja algumas das principais marcas disponíveis em nossa loja.
        </p>
      </div>
        <div className="container">
          <BrandSlider />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  margin: 0px 0 60px;
`;
